import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_LEAVE_GET_TYPES_BY_CONTRACT,
  MY_LEAVE_TYPES_BY_CONTRACT_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcCurrentUserState, useOcPolling } from "oc/hooks";
import { isValidDate } from "oc/utils/is-valid-date";

export const useMyLeaveTypesByContract = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => {
  let { contractCode } = useOcCurrentUserState();

  let skip = !isValidDate(startDate) || !isValidDate(endDate);

  const { data, loading, error } = useQuery(MY_LEAVE_GET_TYPES_BY_CONTRACT, {
    skip: !contractCode || skip,
    pollInterval: useOcPolling(1000 * 60),
    variables: { contract: contractCode, startDate, endDate },
  });

  const { data: subsData } = useSubscription(
    MY_LEAVE_TYPES_BY_CONTRACT_SUBSCRIPTION,
    {
      skip: !contractCode || skip,
      variables: { contract: contractCode, startDate, endDate },
    },
  );

  return {
    leaveTypesByContract:
      subsData?.leaveTypesByContract || data?.leaveTypesByContract || [],
    leaveTypesByContractLoading: loading,
    leaveTypesByContractError: error,
  };
};

export default useMyLeaveTypesByContract;
